import React from 'react'
import { connect } from 'react-redux'
import { forEach, size, get } from 'lodash'

import helpers from '../helpers'
import utils from '../../../utils'

import MarkerWithLabel from './MarkerWithLabel'

class SameDayOrderGuide extends React.Component {
  state = {
    receivers: {},
    customerOrders: {},
    selectedOrderKeys: [],
  }

  componentDidMount() {
    const { orders, onMounted } = this.props

    this.generateCustomerOrders(orders)
    onMounted(this)
  }

  componentDidUpdate(prevProps) {
    const { orders } = this.props

    if (orders !== prevProps.orders)
      this.generateCustomerOrders(orders)
  }

  generateCustomerOrders = orders => {
    const { groupedOrderKeys } = this.props

    const customerOrders = {}
    const orderKeys = Object.keys(orders)
    const orderCount = orderKeys.length

    for(let index = 0; index < orderCount; index += 1) {
      const orderKey = orderKeys[index]
      const order = orders[orderKey]

      if (!groupedOrderKeys.includes(orderKey)) {
        customerOrders[orderKey] = order
      }
    }

    this.setState({ customerOrders })
  }

  generateReceivers = selectedOrderKeys => {
    const { orders } = this.props

    const newReceivers = {}
    const selectedOrderCount = selectedOrderKeys.length

    for(let index = 0; index < selectedOrderCount; index += 1) {
      const key = selectedOrderKeys[index]
      const { receivers } = orders[key]

      forEach(receivers, (receiver, receiverkey) => {
        const receiverAddressKey = `${key}-${receiverkey}`

        newReceivers[receiverAddressKey] = {
          key: receiverkey,
          name: receiver.receiver_name,
          location: {
            latitude: receiver.latitude,
            longitude: receiver.longitude
          },
        }
      })
    }

    this.setState({ receivers: newReceivers })
  }

  onCreateGroup = () => {
    const { selectedOrderKeys } = this.state
    const { createNewGroup } = this.props

    if (selectedOrderKeys.length === 0) {
      alert('Please select order')
      return false
    }

    createNewGroup(selectedOrderKeys)
    return true
  }

  onClearMarkers = () => {
    this.setState({ selectedOrderKeys: [], receivers: {} })
  }

  onSenderClick = (key) => {
    const { selectedOrderKeys } = this.state
    let newSelectedOrderKeys = [...selectedOrderKeys, key]

    if (!selectedOrderKeys.includes(key)) {
      this.setState({ selectedOrderKeys: newSelectedOrderKeys })
    } else {
      newSelectedOrderKeys = selectedOrderKeys.filter(orderKey => orderKey !== key)

      this.setState({ selectedOrderKeys: newSelectedOrderKeys })
    }

    this.generateReceivers(newSelectedOrderKeys)
  }

  renderSenderMarker = orderKey => {
    const { selectedOrderKeys } = this.state
    const { orders } = this.props

    const order = orders[orderKey]
    const latitude = get(order, 'pickup_location.latitude', null)
    const longitude = get(order, 'pickup_location.longitude', null)
    const name = get(order, 'sender_name', 'N/A')
    const isActive = selectedOrderKeys.includes(orderKey)

    const location = { latitude, longitude }

    return (
      <MarkerWithLabel
        key={orderKey}
        opacity={isActive ? 1: 0.4}
        location={location}
        icon={helpers.icons.deliveryLocation}
        label={isActive ? name : null}
        labelColor={helpers.getLabelColor('available')}
        onClick={() => this.onSenderClick(orderKey)}
      />
    )
  }

  renderReceiverMarker = receiverKey => {
    const { receivers } = this.state

    const receiver = receivers[receiverKey]
    const { location, name } = receiver

    return (
      <MarkerWithLabel
        key={receiverKey}
        location={location}
        icon={helpers.icons.restaurant}
        label={name}
        labelColor={helpers.getLabelColor()}
      />
    )
  }

  render() {
    const { customerOrders, receivers } = this.state

    const customerAddresses = Object.keys(customerOrders)
    const customerCount = size(customerAddresses)

    const receiversAddress = Object.keys(receivers)
    const receiverCount = size(receiversAddress)

    const displayMarkers = []

    for (let index = 0; index < customerCount; index += 1) {
      const orderKey = customerAddresses[index]
      displayMarkers.push(this.renderSenderMarker(orderKey))
    }

    for (let index = 0; index < receiverCount; index += 1) {
      const receiverKey = receiversAddress[index]
      displayMarkers.push(this.renderReceiverMarker(receiverKey))
    }

    return displayMarkers
  }
}

const mapState = ({ express }) => ({
  orders: utils.helpers.getExpressPendingStatus(express.sameDayOrders)
})

export default connect(mapState)(SameDayOrderGuide)


// WEBPACK FOOTER //
// ./src/containers/mapView/components/SameDayOrderGuide.js